var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect } from 'react';
import { AnimatePresence, m } from 'framer-motion';
import styled from 'styled-components';
import { SecondaryNavZIndex } from '../NavBar/constants';
var Wrapper = styled(m.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  right: 0;\n  width: 100%;\n  z-index: ", ";\n"], ["\n  position: fixed;\n  right: 0;\n  width: 100%;\n  z-index: ", ";\n"])), SecondaryNavZIndex);
var defaultTransition = {
    duration: 0.5
};
export var SecondaryNavContainer = function (_a) {
    var _b = _a.primaryNavHeight, primaryNavHeight = _b === void 0 ? 76 : _b, children = _a.children, _c = _a.transitionIn, transitionIn = _c === void 0 ? defaultTransition : _c, _d = _a.transitionOut, transitionOut = _d === void 0 ? defaultTransition : _d, _e = _a.fadeIn, fadeIn = _e === void 0 ? false : _e, _f = _a.showVisibleDelay, showVisibleDelay = _f === void 0 ? 0 : _f;
    var _g = useState(false), isVisible = _g[0], setIsVisible = _g[1];
    var _h = useState(0), lastScrollY = _h[0], setLastScrollY = _h[1];
    useEffect(function () {
        var handleScroll = function () {
            var currentScrollY = window.scrollY;
            var getShouldHide = function () {
                return window.scrollY > lastScrollY ||
                    window.scrollY === 0 ||
                    window.scrollY < primaryNavHeight;
            };
            var getShouldShow = function () {
                return window.scrollY < lastScrollY && window.scrollY > primaryNavHeight;
            };
            if (isVisible && getShouldHide()) {
                setIsVisible(false);
            }
            else if (!isVisible && getShouldShow()) {
                setTimeout(function () {
                    if (getShouldShow())
                        setIsVisible(true);
                }, showVisibleDelay);
            }
            setLastScrollY(currentScrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isVisible, lastScrollY, primaryNavHeight, showVisibleDelay]);
    return (React.createElement(AnimatePresence, null, isVisible && (React.createElement(Wrapper, { initial: {
            top: 0,
            opacity: fadeIn ? 0 : 1
        }, animate: {
            top: primaryNavHeight,
            opacity: fadeIn ? 1 : 1,
            transition: transitionIn
        }, exit: {
            top: 0,
            opacity: fadeIn ? 0 : 1,
            transition: transitionOut
        } }, children))));
};
var templateObject_1;
